// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading__loading","spinner":"Loading__spinner"};